import { useMutation } from 'data-fetching-client';
import { UPDATE_BETA_ENROLLMENT } from '../queries';
import { EnrollTypes, EnrollmentStatuses } from '../constants';
export default function useUpdateBetaEnrollment({
  betaAccessType,
  desiredState,
  portalId,
  rolloutId,
  userId
}, options) {
  return useMutation(UPDATE_BETA_ENROLLMENT, Object.assign({}, options, {
    variables: {
      requestToDisable: {
        betaAccessType,
        enrollId: desiredState === EnrollmentStatuses.USER ? portalId : userId,
        enrollType: desiredState === EnrollmentStatuses.USER ? EnrollTypes.PORTALS_ONLY : EnrollTypes.USERS_ONLY,
        portalId,
        rolloutId
      },
      requestToEnable: {
        betaAccessType,
        enrollId: desiredState === EnrollmentStatuses.USER ? userId : portalId,
        enrollType: desiredState === EnrollmentStatuses.USER ? EnrollTypes.USERS_ONLY : EnrollTypes.PORTALS_ONLY,
        portalId,
        rolloutId
      }
    }
  }));
}